import cx from 'classnames'
import { FC, useRef } from 'react'
import { useParallaxScale } from 'src/hooks/useParallax'

import * as SC from './styled'

export type ParallaxShapeProps = {
  className?: string
  color: string
  ratio?: { x: number; y: number }
}

const ParallaxShape: FC<ParallaxShapeProps> = ({ className, color, ratio }) => {
  const ref = useRef<HTMLDivElement>(null)

  const { transform } = useParallaxScale({
    ratioX: ratio?.x,
    ratioY: ratio?.y,
    ref,
  })

  return (
    <SC.Shape
      className={cx('ParallaxShape', className)}
      style={{ scaleX: transform.x, scaleY: transform.y }}
      ref={ref}
      $color={color}
    />
  )
}

export default ParallaxShape
